import { Injectable } from '@angular/core';
import { format,parse,differenceInSeconds } from 'date-fns';

import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
    ,DriveScheduleRow
    ,DriveScheduleItem
    ,DriveScheduleTrip
    ,DriveScheduleRest
} from "src/app/shared/vo";

@Injectable({providedIn: 'root'})
export class FvmsDtgDriveScheduleRestService {
    // subjectListRow:DriveScheduleRow[] = [];
    private schemaName:string = "dtg_rest";
    private idb:IDBDatabase;
    private tbNameSchedule:string = "schedule";
    private tbNameTrip:string = "trip";
    private tbNameIdle:string = "idle";

    constructor(
        
    ) {

    }

    checkIndexDbSupport(){
        if(!('indexedDB' in window)) {
            console.log('This browser doesn\'t support IndexedDB');
            return false;
        }else{
            console.log('This browser support IndexedDB');
            return true;
        }
    }

    initDb(){
        let promise = new Promise((resolve,reject) => {
            let idbFactory = indexedDB;
            let dbPromise = idbFactory.open(this.schemaName,1);
            dbPromise.onerror = (err:any) => {
                console.error("db open err",err);
                reject(err);
            };
            // 호출순서:1
            dbPromise.onupgradeneeded = (evt:any) => {
                // console.log("onupgradeneeded",evt.target.result);
                this.idb = evt.target.result;
                let tx:IDBTransaction = evt.target.transaction;

                if(this.idb.objectStoreNames.contains(this.tbNameSchedule)){
                    this.idb.deleteObjectStore(this.tbNameSchedule);
                }
                if(this.idb.objectStoreNames.contains(this.tbNameTrip)){
                    this.idb.deleteObjectStore(this.tbNameTrip);
                }
                if(this.idb.objectStoreNames.contains(this.tbNameIdle)){
                    this.idb.deleteObjectStore(this.tbNameIdle);
                }

                let dbOptSchedule:IDBObjectStoreParameters = {
                    keyPath:"id"
                    ,autoIncrement:false
                };
                let tbSchedule = this.idb.createObjectStore(this.tbNameSchedule,dbOptSchedule);
                tbSchedule.createIndex(`idx_${this.tbNameSchedule}_01`,["userId","dtgRegDtFrom"],{unique:true});
                tbSchedule.createIndex(`idx_${this.tbNameSchedule}_02`,["userId","dtgRegDt"]);
                tbSchedule.createIndex(`idx_${this.tbNameSchedule}_dtgUnitId`,"dtgUnitId");
                tbSchedule.createIndex(`idx_${this.tbNameSchedule}_dtgRegDtFrom`,"dtgRegDtFrom");

                let dbOptTrip:IDBObjectStoreParameters = {
                    keyPath:"id"
                    ,autoIncrement:false
                };
                let tbTrip = this.idb.createObjectStore(this.tbNameTrip,dbOptTrip);
                tbTrip.createIndex(`idx_${this.tbNameTrip}_01`,["dtgUnitId","dtgRegDtFrom"],{unique:true});
                tbTrip.createIndex(`idx_${this.tbNameTrip}_durMinuteTrip`,"durMinuteTrip",{unique:false});

                let dbOptIdle:IDBObjectStoreParameters = {
                    keyPath:"id"
                    ,autoIncrement:false
                };
                let tbIdle = this.idb.createObjectStore(this.tbNameIdle,dbOptIdle);
                tbIdle.createIndex(`idx_${this.tbNameIdle}_01`,["dtgUnitId","dtgRegDtFrom"],{unique:true});
                tbIdle.createIndex(`idx_${this.tbNameIdle}_durMinuteRest`,"durMinuteRest",{unique:false});

                useDb(this.idb);
                tx.oncomplete = function(evtTx){
                    resolve(evt.target.result);
                }
            };
            // 호출순서:2
            dbPromise.onsuccess = (evt:any) => {
                // console.log("onsuccess",evt.target.result);
                this.idb = evt.target.result;
                useDb(this.idb);
                resolve(this.idb);
            };

            function useDb(idb){
                idb.onversionchange = function(event) {
                    idb.close();
                    console.log("A new version of this page is ready. Please reload or close this tab!");
                };
            }
        });
        return promise;
    }

    clearTbSchedule(){
        let promise = new Promise<void>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameSchedule],"readwrite");
            tx.oncomplete = () => {
                resolve();
            };
            tx.onerror = (err) => {
                reject();
            };
            let tbSchedule = tx.objectStore(this.tbNameSchedule);
            tbSchedule.clear();
        });
        return promise;
    }

    clearTbTrip(){
        let promise = new Promise<void>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameTrip],"readwrite");
            tx.oncomplete = () => {
                resolve();
            };
            tx.onerror = (err) => {
                reject();
            };
            let tbTrip = tx.objectStore(this.tbNameTrip);
            tbTrip.clear();
        });
        return promise;
    }

    clearTbIdle(){
        let promise = new Promise<void>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameIdle],"readwrite");
            tx.oncomplete = () => {
                resolve();
            };
            tx.onerror = (err) => {
                reject();
            };
            let tbIdle = tx.objectStore(this.tbNameIdle);
            tbIdle.clear();
        });
        return promise;
    }

    insertListSchedule(listItem:any[]){
        let promise = new Promise(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameSchedule],"readwrite");
            tx.oncomplete = () => {
                resolve(listItem);
            };
            tx.onerror = (err) => {
                // console.error("tx.onerror",err);
                reject(listItem);
            };
            let tbSchedule = tx.objectStore(this.tbNameSchedule);
            if(listItem){
                let sizeListItem = listItem.length;
                for(let a=0;a<sizeListItem;a++){
                    let item = listItem[a];
                    item.id = `${item.userId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
                    item.idRow = `${item.userId}-${item.dtgRegDt.replace(/[\s:]+/g,"-")}`;
                    tbSchedule.add(item);
                }
            }
        });
        return promise;
    }

    insertListTrip(listItem:any[]){
        let promise = new Promise(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameTrip],"readwrite");
            tx.oncomplete = () => {
                resolve(listItem);
            };
            tx.onerror = (err) => {
                // console.error("tx.onerror",err);
                reject(listItem);
            };
            let tbTrip = tx.objectStore(this.tbNameTrip);
            if(listItem){
                let sizeListItem = listItem.length;
                for(let a=0;a<sizeListItem;a++){
                    let item = listItem[a];
                    item.id = `${item.dtgUnitId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
                    let itemTrip = new DriveScheduleTrip();
                    itemTrip.import(item);
                    itemTrip.durMinuteTrip = itemTrip.getDurMinuteTrip();
                    tbTrip.add(itemTrip);
                }
            }
        });
        return promise;
    }

    insertListIdle(listItem:any[]){
        let promise = new Promise(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameIdle],"readwrite");
            tx.oncomplete = () => {
                resolve(listItem);
            };
            tx.onerror = (err) => {
                // console.error("tx.onerror",err);
                reject(listItem);
            };
            let tbIdle = tx.objectStore(this.tbNameIdle);
            if(listItem){
                let sizeListItem = listItem.length;
                for(let a=0;a<sizeListItem;a++){
                    let item = listItem[a];
                    item.id = `${item.dtgUnitId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
                    let itemIdle = new DriveScheduleRest();
                    itemIdle.import(item);
                    itemIdle.durMinuteRest = itemIdle.getDurMinuteRest();
                    tbIdle.add(itemIdle);
                }
            }
        });
        return promise;
    }

    findAllSchedule(){
        let promise = new Promise<any[]>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameSchedule],"readwrite");
            let tbSchedule = tx.objectStore(this.tbNameSchedule);
            let resSchedule = tbSchedule.getAll();
            resSchedule.onsuccess = function(e:any){
                resolve(e.target.result);
            }
        });
        return promise;
    }

    findAllTrip(limitMinTrip:number){
        let promise = new Promise<any[]>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameTrip],"readwrite");
            let tbTrip = tx.objectStore(this.tbNameTrip);
            let idxTrip = tbTrip.index(`idx_${this.tbNameTrip}_durMinuteTrip`);
            let searchOpt = IDBKeyRange.lowerBound(limitMinTrip);
            let resTrip = idxTrip.getAll(searchOpt);
            resTrip.onsuccess = function(e:any){
                resolve(e.target.result);
            }
        });
        return promise;
    }

    findAllIdle(limitMinRest:number){
        let promise = new Promise<any[]>(async (resolve,reject) => {
            let tx:IDBTransaction = this.idb.transaction([this.tbNameIdle],"readwrite");
            let tbIdle = tx.objectStore(this.tbNameIdle);
            let idxIdle = tbIdle.index(`idx_${this.tbNameIdle}_durMinuteRest`);
            let searchOpt = IDBKeyRange.lowerBound(limitMinRest);
            let resIdle = idxIdle.getAll(searchOpt);
            resIdle.onsuccess = function(e:any){
                resolve(e.target.result);
            }
        });
        return promise;
    }

    createRow(listSchedule:any[],minTrip:number,minRest:number){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            if(listSchedule){
                let listRow = [];
                let sizeListSchedule = listSchedule.length;
                for(let a=0;a<sizeListSchedule;a++){
                    let item = listSchedule[a];
                    let scheduleRow = new DriveScheduleRow();
                    scheduleRow.import(item);
                    scheduleRow.limitMinuteTrip = minTrip;
                    scheduleRow.limitMinuteRest = minRest;
                    scheduleRow.id = `${item.userId}-${item.dtgRegDt.replace(/[\s:]+/g,"-")}`;
                    let scheduleItem = new DriveScheduleItem();
                    scheduleItem.import(item);
                    let searchKey = `${scheduleItem.userId}-${scheduleItem.dtgRegDt.replace(/[\s:]+/g,"-")}`;

                    // 동일 운전자에 시작일자가 같은 레코드를 찾는다
                    let foundRow = listRow.find((searchRow) => {
                        return searchRow.id === searchKey;
                    });

                    if(foundRow){
                        // 찾았다
                        foundRow.listSchedule.push(scheduleItem);
                    }else{
                        // 없다 -> 신규 추가
                        scheduleItem.idRow = scheduleRow.id;
                        scheduleItem.idxRow = listRow.length;
                        scheduleRow.listSchedule = [scheduleItem];
                        scheduleRow.listTrip = [];
                        scheduleRow.listRest = [];
                        listRow.push(scheduleRow);
                    }
                }

                this.sortListScheduleInRow(listRow).then(() => {
                    resolve(listRow);
                });
            }
        });
        return promise;
    }

    sortListScheduleInRow(listRow:DriveScheduleRow[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            if(listRow){
                let sizeListRow = listRow.length;
                for(let a=0;a<sizeListRow;a++){
                    listRow[a].sortSchedule("asc");
                }
            }
            resolve(listRow);
        });
        return promise;
    }

    // row 에 회차별 정보 생성
    addListTrip(listRow:DriveScheduleRow[],listTrip:any[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            if(listTrip){
                let sizeListTrip = listTrip.length;
                let listPromise = [];
                for(let a=0;a<sizeListTrip;a++){
                    let itemTrip = new DriveScheduleTrip();
                    itemTrip.import(listTrip[a]);
                    itemTrip.id = `${itemTrip.dtgUnitId}-${itemTrip.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
                    itemTrip.durMinuteTrip = itemTrip.getDurMinuteTrip();
                    listPromise.push(this.addTrip(itemTrip,listRow));
                }
                Promise.all(listPromise).then(() => {
                    this.sortListTripInRow(listRow).then((newListRow:DriveScheduleRow[]) => {
                        resolve(newListRow);
                    });
                });
            }
        });
        return promise;
    }

    // row 에 회차별 정보 생성
    addTrip(itemTrip:any,listRow:DriveScheduleRow[]){
        let promise = new Promise<void>((resolve) => {
            if(itemTrip){
                let tmpItemTrip = new DriveScheduleTrip();
                tmpItemTrip.import(itemTrip);
                let sizeListRow = listRow.length;
                for(let b=0;b<sizeListRow;b++){
                    let itemRow:DriveScheduleRow = listRow[b];// row
                    itemRow.addItemTrip(b,itemTrip);
                }
            }
            resolve();
        });
        return promise;
    }

    // 회차별 정보를 재정렬
    sortListTripInRow(listRow:DriveScheduleRow[]){
        let promise = new Promise((resolve) => {
            if(listRow){
                let sizeListRow = listRow.length;
                for(let a=0;a<sizeListRow;a++){
                    listRow[a].sortTrip("asc");
                }
            }
            resolve(listRow);
        });
        return promise;
    }

    // 공회전 정보를 입력
    addListRest(listRow:DriveScheduleRow[],listRest){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            if(listRest){
                let sizeListRest = listRest.length;
                let listPromise = [];
                for(let a=0;a<sizeListRest;a++){
                    let itemRest = new DriveScheduleRest();
                    itemRest.import(listRest[a]);
                    itemRest.id = `${itemRest.dtgUnitId}-${itemRest.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
                    itemRest.durMinuteRest = itemRest.getDurMinuteRest();
                    listPromise.push(this.addRest(itemRest,listRow));
                }
                Promise.all(listPromise).then(() => {
                    // 회차 정보가 변경되었으니 재정렬 해야한다
                    this.sortListTripInRow(listRow).then((listRowSorted:DriveScheduleRow[]) => {
                        resolve(listRowSorted);
                    });
                });
            }
        });
        return promise;
    }

    addRest(itemRest:any,listRow:DriveScheduleRow[]){
        let promise = new Promise<void>((resolve) => {
            let tmpItemRest = new DriveScheduleRest();
            tmpItemRest.import(itemRest);
            let sizeListRow = listRow.length;
            for(let b=0;b<sizeListRow;b++){
                let itemRow:DriveScheduleRow = listRow[b];// row
                itemRow.addItemRest(b,itemRest);
            }
            resolve();
        });
        return promise;
    }

    // 각 회차의 휴식 시작/종료로 배차정보 업데이트
    updateDtRest(listRow:DriveScheduleRow[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            let listPromise1 = [];
            let listPromise2 = [];
            if(listRow){
                let sizeListRow = listRow.length;
                for(let b=0;b<sizeListRow;b++){
                    let itemRow:DriveScheduleRow = listRow[b];// row
                    listPromise1.push(itemRow.updateDtTrip());//배차시간 업데이트
                    listPromise2.push(itemRow.updateDtRest());//현재/다음 회차로 휴식시간 업데이트
                }
            }
            Promise.all(listPromise1).then(() => {
                Promise.all(listPromise2).then(() => {
                    resolve(listRow);
                });
            });
        });
        return promise;
    }

    // 휴식시간이 검색조건보다 작으면 현재와 뒤의 운행시간을 합한다
    reRangeMinRest(listRow:DriveScheduleRow[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            let listPromise = [];
            if(listRow){
                let sizeListRow = listRow.length;
                for(let a=0;a<sizeListRow;a++){
                    let itemRow = listRow[a];// row
                    listPromise.push(itemRow.reRangeMinRest());
                }
            }
            Promise.all(listPromise).then(() => {
                resolve(listRow);
            });
        });
        return promise;
    }

    // 공회전으로 운행일시를 조절했으므로 제외시간에 걸리는 아이템이 발생한다
    // 선택한 제외시간 보다 작은 아이템은 제거
    // 운행시간이 검색조건보다 작으면 현재와 앞의 휴식시간과 합한다
    // 휴식시간이 검색조건보다 큰것만 남았으므로 운행시간을 삭제하고 휴식시간을 합쳤을때
    // 휴식시간이 검색조건보다 작은것을 다시 검색 할 필요없다
    reRangeMinTrip(listRow:DriveScheduleRow[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            let listPromise = [];
            if(listRow){
                for(let a=0;a<listRow.length;a++){
                    let itemRow:DriveScheduleRow = listRow[a];// row
                    listPromise.push(itemRow.reRangeMinDrive());
                }
            }
            Promise.all(listPromise).then(() => {
                if(listRow){
                    let idxRow = 0;
                    while(idxRow < listRow.length){
                        let itemRow:DriveScheduleRow = listRow[idxRow];// row
                        if(itemRow.listTrip && itemRow.listTrip.length <= 1){
                            if(itemRow.listTrip.length === 0){
                                listRow.splice(idxRow,1);
                                continue;
                            }
                            if(itemRow.listTrip[0].getDurMinuteTrip() < itemRow.limitMinuteTrip){
                                // row 는 있는데 운행이 하나만 있다
                                // 하나 있는 운행마저 제외시간보다 작다
                                // row 를 제거
                                listRow.splice(idxRow,1);
                                continue;
                            }
                        }
                        idxRow++;
                    }
                }
                resolve(listRow);
            });
        });
        return promise;
    }

    //1.시내,농어촌 및 마을버스
    //  - 각 회차 종료 후 10분 이상 휴식 보장
    //  - 회차 운행시간 2시간 이상일 경우 15분 이상 휴식 보장
    //  - 회차 운행시간 4시간 이상일 경우 30분 이상 휴식 보장
    //2.시외(고속)버스 / 전세버스
    //  - 각 회차 종료 후 15분 이상 휴식 보장
    //  - 회차 운행시간 3시간 이상일 경우 30분 이상 휴식 보장
    //3.전체
    //  - 운행 종료시간과 운행 시작시간 사이 8시간 이상 휴식 보장
    //  - 광역급행 및 직행좌석형 시내버스의 경우 10시간 이상 휴식 보장 (코드없어서 처리 못함)
    checkValid(listRow:DriveScheduleRow[]){
        let promise = new Promise<DriveScheduleRow[]>((resolve) => {
            if(listRow){
                let sizeListRow = listRow.length;
                for(let a=0;a<sizeListRow;a++){
                    let itemRowCurr:DriveScheduleRow = listRow[a];// row curr
                    itemRowCurr.checkValidDrive().then(() => {
                        if(a < sizeListRow - 1){
                            try{
                                // 마지막 행은 다음 행이 없으므로 제외
                                // 다음 아이템 하나만 찾으면 된다
                                // 운행 종료시간과 운행 시작시간 사이 8시간 이상 휴식 보장
                                let itemRowNext:DriveScheduleRow = null;
                                for(let b=a+1;b<sizeListRow;b++){
                                    itemRowNext = listRow[b];// row next
                                    if(itemRowCurr.userId !== itemRowNext.userId){
                                        // 다음 row 가 다른 운전자 운행정보일 수 있으므로
                                        itemRowNext = null;
                                        continue;
                                    }else{
                                        // 다음 아이템 하나만 찾는다
                                        break;
                                    }
                                }

                                if(itemRowNext){
                                    let dtFromObj = itemRowCurr.getItemTripMax();// 현재 행의 마지막 운행 종료시간
                                    let dtToObj = itemRowNext.getItemTripMin();// 다음 행의 처음 운행 시작시간
                                    let dtFrom = dtFromObj.getDtToTripDate();
                                    let dtTo = dtToObj.getDtFromTripDate();
                                    let durRowDiff = Math.floor(differenceInSeconds(dtTo,dtFrom) / 60 / 60);// 몇 시간 차이
                                    let durMinHour = 8;
                                    if(durRowDiff < durMinHour){
                                        // 운행 종료시간과 운행 시작시간 사이 8시간 이상 휴식 보장
                                        itemRowCurr.err["dur.schedule.row.diff.from"] = durRowDiff;
                                        itemRowNext.err["dur.schedule.row.diff.to"] = durRowDiff;

                                        let msg = `<div class="text-nowrap">`;
                                        msg += `from : ${dtFromObj.dtToTrip}`;
                                        msg += `</div>`;
                                        msg += `<div class="text-nowrap">`;
                                        msg += `to : ${dtToObj.dtFromTrip}`;
                                        msg += `</div>`;
                                        msg += `<div class="text-nowrap">`;
                                        msg += `${durRowDiff}시간차이 (최소8시간)`;
                                        msg += `</div>`;
                                        itemRowCurr.msg["dur.schedule.row.diff.from"] = msg;
                                        itemRowNext.msg["dur.schedule.row.diff.to"] = msg;
                                    }
                                }
                            }catch(ex){
                                console.error("checkValid",a,ex);
                            }
                        }
                    });
                }
            }
            resolve(listRow);
        });
        return promise;
    }

    // checkIndexDbSupport(){
    //     if(!('indexedDB' in window)) {
    //         console.log('This browser doesn\'t support IndexedDB');
    //         return false;
    //     }else{
    //         console.log('This browser support IndexedDB');
    //         return true;
    //     }
    // }

    // initDb(){
    //     let promise = new Promise((resolve,reject) => {
    //         let idbFactory = indexedDB;
    //         let dbPromise = idbFactory.open(this.schemaName,1);
    //         dbPromise.onerror = (err:any) => {
    //             console.error("db open err",err);
    //             reject(err);
    //         };
    //         // 호출순서:1
    //         dbPromise.onupgradeneeded = (evt:any) => {
    //             // console.log("onupgradeneeded",evt.target.result);
    //             this.idb = evt.target.result;
    //             let tx:IDBTransaction = evt.target.transaction;

    //             if(this.idb.objectStoreNames.contains(this.tbNameDriveScheduleRow)){
    //                 this.idb.deleteObjectStore(this.tbNameDriveScheduleRow);
    //             }
    //             if(this.idb.objectStoreNames.contains(this.tbNameDriveSchedule)){
    //                 this.idb.deleteObjectStore(this.tbNameDriveSchedule);
    //             }
    //             if(this.idb.objectStoreNames.contains(this.tbNameDriveTrip)){
    //                 this.idb.deleteObjectStore(this.tbNameDriveTrip);
    //             }
    //             if(this.idb.objectStoreNames.contains(this.tbNameDriveIdle)){
    //                 this.idb.deleteObjectStore(this.tbNameDriveIdle);
    //             }

    //             let dbOptDriveScheduleRow:IDBObjectStoreParameters = {
    //                 keyPath:"id"
    //                 ,autoIncrement:false
    //             };
    //             let tbDriveScheduleRow = this.idb.createObjectStore(this.tbNameDriveScheduleRow,dbOptDriveScheduleRow);
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_01`,["userId","dtgRegDtFrom"],{unique:true});
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_02`,["userId","dtgRegDt"],{unique:false});
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_dtgUnitId`,"dtgUnitId",{unique:false});
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_userId`,"userId",{unique:false});
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_dtgRegDtFrom`,"dtgRegDtFrom",{unique:false});
    //             tbDriveScheduleRow.createIndex(`idx_${this.tbNameDriveScheduleRow}_dtgRegDt`,"dtgRegDt",{unique:false});

    //             let dbOptDriveSchedule:IDBObjectStoreParameters = {
    //                 keyPath:"id"
    //                 ,autoIncrement:false
    //             };
    //             let tbDriveSchedule = this.idb.createObjectStore(this.tbNameDriveSchedule,dbOptDriveSchedule);
    //             tbDriveSchedule.createIndex(`idx_${this.tbNameDriveSchedule}_01`,["userId","dtgRegDtFrom"],{unique:true});
    //             tbDriveSchedule.createIndex(`idx_${this.tbNameDriveSchedule}_dtgUnitId`,"dtgUnitId",{unique:false});
    //             tbDriveSchedule.createIndex(`idx_${this.tbNameDriveSchedule}_userId`,"userId",{unique:false});
    //             tbDriveSchedule.createIndex(`idx_${this.tbNameDriveSchedule}_dtgRegDtFrom`,"dtgRegDtFrom",{unique:false});

    //             let dbOptDriveTrip:IDBObjectStoreParameters = {
    //                 keyPath:"id"
    //                 ,autoIncrement:false
    //             };
    //             let tbDriveTrip = this.idb.createObjectStore(this.tbNameDriveTrip,dbOptDriveTrip);
    //             tbDriveTrip.createIndex(`idx_${this.tbNameDriveTrip}_01`,["dtgUnitId","dtgRegDtFrom"],{unique:true});
    //             tbDriveTrip.createIndex(`idx_${this.tbNameDriveTrip}_dtgUnitId`,"dtgUnitId",{unique:false});
    //             tbDriveTrip.createIndex(`idx_${this.tbNameDriveTrip}_userId`,"userId",{unique:false});
    //             tbDriveTrip.createIndex(`idx_${this.tbNameDriveTrip}_dtgRegDtFrom`,"dtgRegDtFrom",{unique:false});

    //             let dbOptDriveIdle:IDBObjectStoreParameters = {
    //                 keyPath:"id"
    //                 ,autoIncrement:false
    //             };
    //             let tbDriveIdle = this.idb.createObjectStore(this.tbNameDriveIdle,dbOptDriveIdle);
    //             tbDriveIdle.createIndex(`idx_${this.tbNameDriveIdle}_01`,["dtgUnitId","dtgRegDtFrom"],{unique:true});
    //             tbDriveIdle.createIndex(`idx_${this.tbNameDriveIdle}_dtgUnitId`,"dtgUnitId",{unique:false});
    //             tbDriveIdle.createIndex(`idx_${this.tbNameDriveIdle}_userId`,"userId",{unique:false});
    //             tbDriveIdle.createIndex(`idx_${this.tbNameDriveIdle}_dtgRegDtFrom`,"dtgRegDtFrom",{unique:false});

    //             useDb(this.idb);
    //             // let tx:IDBTransaction = this.idb.transaction([
    //             //         this.tbNameDriveScheduleRow
    //             //         ,this.tbNameDriveSchedule
    //             //         ,this.tbNameDriveTrip
    //             //         ,this.tbNameDriveIdle
    //             //     ]
    //             //     ,"readwrite");
    //             tx.oncomplete = function(evtTx){
    //                 resolve(evt.target.result);
    //             }
    //             // this.tbDriveSchedule.transaction.oncomplete = function(event) {
    //             //     resolve(evt.target.result);
    //             // };
    //         };
    //         // 호출순서:2
    //         dbPromise.onsuccess = (evt:any) => {
    //             // console.log("onsuccess",evt.target.result);
    //             this.idb = evt.target.result;
    //             useDb(this.idb);
    //             resolve(this.idb);
    //         };

    //         function useDb(idb){
    //             idb.onversionchange = function(event) {
    //                 idb.close();
    //                 console.log("A new version of this page is ready. Please reload or close this tab!");
    //             };
    //         }
    //     });
    //     return promise;
    // }

    // // 동일 운전자에 시작일자가 같은 레코드를 찾아서 병합
    // addListDriveSchedule(listItem:any[]){
    //     let promise = new Promise(async (resolve,reject) => {
    //         let tx:IDBTransaction = this.idb.transaction([this.tbNameDriveSchedule,this.tbNameDriveScheduleRow],"readwrite");
    //         let tbDriveSchedule = tx.objectStore(this.tbNameDriveSchedule);
    //         let tbDriveScheduleRow = tx.objectStore(this.tbNameDriveScheduleRow);
    //         tbDriveSchedule.clear();
    //         tbDriveScheduleRow.clear();

    //         if(listItem){
    //             let sizeListItem = listItem.length;
    //             for(let a=0;a<sizeListItem;a++){
    //                 let item = listItem[a];
    //                 let itemSchedule = Object.setPrototypeOf(item,DtgDriveScheduleItem.prototype);
    //                 itemSchedule.id = `${item.userId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;

    //                 // 동일 운전자에 시작일자가 같은 row를 찾는다
    //                 let foundRow = await this.findOneDriveSchedule(item.userId,item.dtgRegDt);
    //                 // 트랜잭션이 끊어져서 새로 만든다
    //                 tx = this.idb.transaction([this.tbNameDriveSchedule,this.tbNameDriveScheduleRow],"readwrite");
    //                 tbDriveScheduleRow = tx.objectStore(this.tbNameDriveScheduleRow);
    //                 tbDriveSchedule = tx.objectStore(this.tbNameDriveSchedule);
    //                 let idRow = "";// row의 id

    //                 if(!foundRow){
    //                     // console.log("addListDriveSchedule","not",foundRow);
    //                     // 기존 row 가 없다
    //                     let itemRow = Object.setPrototypeOf(item,DtgDriveScheduleRow.prototype);
    //                     // id를 생성하고 입력
    //                     idRow = `${item.userId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
    //                     itemRow.id = idRow;
    //                     await tbDriveScheduleRow.add(itemRow);
    //                 }else{
    //                     // console.log("addListDriveSchedule",foundRow);
    //                     // 기존 row 가 있다
    //                     let itemRow = Object.setPrototypeOf(foundRow,DtgDriveScheduleRow.prototype);
    //                     // console.log("addListDriveSchedule",itemRow);
    //                     if(itemSchedule.getDtToSchedule() >= itemRow.getDtToSchedule()){
    //                         // 현재 item 의 종료일시가 row 보다 이후면 현재 item 의 종료일시로 업데이트
    //                         itemRow.dtgRegDtTo = itemSchedule.dtgRegDtTo;
    //                     }
    //                     await tbDriveScheduleRow.put(itemRow);
    //                 }

    //                 itemSchedule.idRow = idRow;
    //                 await tbDriveSchedule.add(itemSchedule);
    //             }
    //             resolve(listItem);
    //         }
    //         // tx.oncomplete = (evt) => {
    //         //     // console.log("addListDriveSchedule","oncomplete",evt);
    //         //     resolve(listItem);
    //         // };
    //         tx.onerror = (err) => {
    //             reject(listItem);
    //         };
    //     });
    //     return promise;
    // }

    // findOneDriveSchedule(userId:string,dtgRegDt:string){
    //     let promise = new Promise((resolve,reject) => {
    //         // console.log("findOneDriveSchedule");
    //         let tx:IDBTransaction = this.idb.transaction([this.tbNameDriveScheduleRow]);
    //         let tbDriveScheduleRow = tx.objectStore(this.tbNameDriveScheduleRow);
    //         let idxObjRow:IDBIndex = tbDriveScheduleRow.index(`idx_${this.tbNameDriveScheduleRow}_02`);
    //         let req = idxObjRow.get([userId,dtgRegDt]);
    //         req.onsuccess = function(e:any){
    //             // console.log("findOneDriveSchedule",e);
    //             resolve(e.target.result);
    //         };
    //         req.onerror = function(err:any){
    //             console.error("findOneDriveSchedule",err);
    //             reject(err);
    //         };
    //     });
    //     return promise;
    // }

    // getListDriveRowAll():Promise<any>{
    //     let _this = this;
    //     let promise = new Promise(async (resolve,reject) => {
    //         let tx:IDBTransaction = this.idb.transaction(this.tbNameDriveScheduleRow,"readwrite");
    //         let tbDriveRow = tx.objectStore(this.tbNameDriveScheduleRow);
    //         let req = tbDriveRow.getAll();
    //         req.onsuccess = function(e:any){
    //             let listItem = e.target.result;
    //             let tmpList = listItem.map(item => Object.setPrototypeOf(item,DtgDriveScheduleRow.prototype));
    //             _this.subjectListRow.next(tmpList);
    //             resolve(tmpList);
    //         };
    //         req.onerror = function(err:any){
    //             console.error("getListDriveRowAll",err);
    //             reject(null);
    //         };
    //     });
    //     return promise;
    // }

    // getListDriveSchedule(){
    //     let tx:IDBTransaction = this.idb.transaction(this.tbNameDriveSchedule,"readwrite");
    //     let tbDriveSchedule = tx.objectStore(this.tbNameDriveSchedule);
    //     // let idxObj:IDBIndex = tbDriveSchedule.index(`idx_${this.tbNameDriveSchedule}_dtFrom`);
    //     let idxObj:IDBIndex = tbDriveSchedule.index(`idx_${this.tbNameDriveSchedule}_dtgRegDtFrom`);
    //     // let searchOpt1 = IDBKeyRange.lowerBound(["","2021-04-01 00:00:00"],false);
    //     // let searchOpt2 = IDBKeyRange.upperBound(["*","2021-04-02 00:00:00"],false);
    //     let searchOptAll = IDBKeyRange.bound(
    //         ["01223411646","2021-04-01 00:00:00"]
    //         ,["01223411646","2021-04-03 00:00:00"]
    //         ,false
    //         ,false
    //     );
    //     // let dtMin = parse("2021-04-01 00:00:00","yyyy-MM-dd HH:mm:ss",new Date()).getTime();
    //     // let dtMax = parse("2021-04-03 00:00:00","yyyy-MM-dd HH:mm:ss",new Date()).getTime();
    //     // let dtMin = "2021-04-01 00:00:00";
    //     // let dtMax = "2021-04-03 00:00:00";
    //     // console.log("dtMin",dtMin,"dtMax",dtMax);
    //     // // 1617204600000
    //     // let searchOptAll = IDBKeyRange.bound(
    //     //     dtMin
    //     //     ,dtMax
    //     //     ,false
    //     //     ,false
    //     // );
    //     idxObj.openCursor(searchOptAll).onsuccess = (evt:any) => {
    //         // console.log("openCursor",evt);
    //         var cursor = evt.target.result;
    //         if(cursor) {
    //             // Do something with the matches.
    //             // console.log("getListDriveSchedule cursor",cursor);
    //             cursor.continue();
    //         }
    //     };
    // }

    // getListDriveScheduleAll(){
    //     let promise = new Promise((resolve,reject) => {
    //         // console.log("getListDriveScheduleAll");
    //         let tx:IDBTransaction = this.idb.transaction(this.tbNameDriveSchedule,"readwrite");
    //         let tbDriveSchedule = tx.objectStore(this.tbNameDriveSchedule);
    //         let req = tbDriveSchedule.getAll();
    //         req.onsuccess = function(e:any){
    //             // console.log("getListDriveScheduleAll",e);
    //             let listItem = e.target.result;
    //             let tmpList = listItem.map(item => Object.setPrototypeOf(item,DtgDriveScheduleItem.prototype));
    //             resolve(tmpList);
    //         };
    //         req.onerror = function(err:any){
    //             console.error("getListDriveScheduleAll",err);
    //             reject(err);
    //         };
    //     });
    //     return promise;
    // }

    // addListDriveTrip(listItem:any[]){
    //     let promise = new Promise(async (resolve,reject) => {
    //         let tx:IDBTransaction = this.idb.transaction([this.tbNameDriveSchedule,this.tbNameDriveTrip],"readwrite");
    //         let tbDriveTrip = tx.objectStore(this.tbNameDriveTrip);
    //         tbDriveTrip.clear();

    //         if(listItem){
    //             let sizeListItem = listItem.length;
    //             let listSchedule:any = await this.getListDriveScheduleAll();
    //             let sizeListSchedule = listSchedule.length;
    //             tx = this.idb.transaction([this.tbNameDriveSchedule,this.tbNameDriveTrip],"readwrite");
    //             tbDriveTrip = tx.objectStore(this.tbNameDriveTrip);

    //             for(let a=0;a<sizeListItem;a++){
    //                 let item = listItem[a];
    //                 let itemTrip = Object.setPrototypeOf(item,DtgDriveScheduleItemDrive.prototype);
    //                 itemTrip.import(item);
    //                 itemTrip.id = `${item.dtgUnitId}-${item.dtgRegDtFrom.replace(/[\s:]+/g,"-")}`;
    //                 for(let b=0;b<sizeListSchedule;b++){
    //                     let itemSchedule = listSchedule[b];
    //                     itemSchedule = Object.setPrototypeOf(itemSchedule,DtgDriveScheduleItem.prototype);
    //                     // 배차정보 : 누가,어느차량을,언제부터,언제까지 (어느차량을 + 언제부터 unique key)
    //                     let dtFromSchedule = itemSchedule.getDtFromSchedule();//배차시작
    //                     let dtToSchedule = itemSchedule.getDtToSchedule();//배차종료
    //                     let dtFromDrive = itemTrip.getDtFromDrive();//운행시작
    //                     let dtToDrive = itemTrip.getDtToDrive();//운행종료

    //                     // 배차 범위에 운행이 있을 때
    //                     if(dtFromDrive.getTime() >= dtFromSchedule.getTime() && dtFromDrive.getTime() <= dtToSchedule.getTime()){
    //                         // 운행 시작이 배차 시작<->종료에 포함될때
    //                         itemTrip.idRow = itemSchedule.idRow;//어느 행인지
    //                         itemTrip.idSchedule = itemSchedule.id;//어느 배차정보에 포함되는지
    //                         if(dtToDrive.getTime() >= dtToSchedule.getTime()){
    //                             // 운행 종료가 배차 종료보다 크면 운행 종료는 배차 종료로 변경
    //                             itemTrip.dtToDrive = itemSchedule.dtgRegDtTo;
    //                             itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
    //                         }
    //                         await tbDriveTrip.add(itemTrip);
    //                         continue;
    //                     }
    //                     if(dtToDrive.getTime() >= dtFromSchedule.getTime() && dtToDrive.getTime() <= dtToSchedule.getTime()){
    //                         // 운행 종료가 배차 시작<->종료에 포함될때
    //                         itemTrip.idRow = itemSchedule.idRow;//어느 행인지
    //                         itemTrip.idSchedule = itemSchedule.id;//어느 배차정보에 포함되는지
    //                         if(dtFromDrive.getTime() <= dtFromSchedule.getTime()){
    //                             // 운행 시작이 배차 시작보다 작으면 운행 시작은 배차 시작으로 변경
    //                             itemTrip.dtFromDrive = itemSchedule.dtgRegDtFrom;
    //                         }
    //                         await tbDriveTrip.add(itemTrip);
    //                         continue;
    //                     }

    //                     // 운행 범위 안에 배차가 있을 때
    //                     if(dtFromSchedule.getTime() >= dtFromDrive.getTime() && dtFromSchedule.getTime() <= dtToDrive.getTime()){
    //                         // 배차 시작이 운행 시작<->종료에 포함될때
    //                         itemTrip.idRow = itemSchedule.idRow;//어느 행인지
    //                         itemTrip.idSchedule = itemSchedule.id;//어느 배차정보에 포함되는지
    //                         itemTrip.dtFromDrive = itemSchedule.dtgRegDtFrom;//운행 시작은 배차 시작으로 변경
    //                         if(dtToDrive.getTime() >= dtToSchedule.getTime()){
    //                             // 운행 종료가 배차 종료보다 크면 운행 종료는 배차 종료로 변경
    //                             itemTrip.dtToDrive = itemSchedule.dtgRegDtTo;
    //                             itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
    //                         }
    //                         await tbDriveTrip.add(itemTrip);
    //                         continue;
    //                     }
    //                     if(dtToSchedule.getTime() >= dtFromDrive.getTime() && dtToSchedule.getTime() <= dtToDrive.getTime()){
    //                         // 배차 종료가 운행 시작<->종료에 포함될때
    //                         itemTrip.idRow = itemSchedule.idRow;//어느 행인지
    //                         itemTrip.idSchedule = itemSchedule.id;//어느 배차정보에 포함되는지
    //                         itemTrip.dtToDrive = itemSchedule.dtgRegDtTo;//운행 종료는 배차 종료로 변경
    //                         itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
    //                         if(dtFromDrive.getTime() <= dtFromSchedule.getTime()){
    //                             // 운행 시작이 배차 시작보다 작으면 운행 시작은 배차 시작으로 변경
    //                             itemTrip.dtFromDrive = itemSchedule.dtgRegDtFrom;
    //                         }
    //                         await tbDriveTrip.add(itemTrip);
    //                         continue;
    //                     }
    //                 }
    //             }
    //             resolve(listItem);
    //         }
    //         // tx.oncomplete = (evt) => {
    //         //     // console.log("addListDriveSchedule","oncomplete",evt);
    //         //     resolve(listItem);
    //         // };
    //         tx.onerror = (err) => {
    //             reject(listItem);
    //         };
    //     });
    //     return promise;
    // }
}